import { HiOutlineMenu } from "react-icons/hi";
import { FaBtc } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { useGlobalContext } from "../store/context";
import Modal from "../ui/Modal";
import NavbarModal from "./modalComponents/NavbarModal";
import * as ROUTES from "../constants/routes";

function Navbar() {
  const { isNavbarModalOpen, openNavbarModal, closeNavbarModal } =
    useGlobalContext();
  const location = useLocation();

  return (
    <div className="h-[60px] px-3 flex items-center justify-between shadow-md bg-[#1e293b] text-[#94a3b8]">
      <div className="flex items-center gap-4">
        <div
          onClick={openNavbarModal}
          className={`hoverAnimation w-10 h-10 flex justify-center items-center  ${
            location.pathname === "/" && "hidden"
          }`}
        >
          <HiOutlineMenu className="w-7 h-7" />
        </div>

        <Link to={ROUTES.DASHBOARD} className=" text-2xl px-2 text-[#ff9900]">
          <span>
            <FaBtc className="w-10 h-10" />
          </span>
        </Link>

        {/* the navbar modal */}
        <Modal
          component={<NavbarModal />}
          modalState={isNavbarModalOpen}
          close={closeNavbarModal}
          type="navbarModal"
        />
      </div>

      <div>
        {/* <div className="hoverAnimation w-10 h-10 flex justify-center items-center">
          <HiOutlineUserCircle className="w-7 h-7" />
        </div> */}
      </div>
    </div>
  );
}

export default Navbar;
